<wr-base-dialog status="primary" [header]="header" submitText="Speichern"
                [submitResponse]="onSubmit" [disableSubmit]="form.invalid">
  <hau-form [formGroup]="form">
    <hau-form-field label="Name">
      <input nbInput fullWidth formControlName="name" required>
    </hau-form-field>
    <hau-form-field label="Farbe">
      <wr-color-preset-picker formControlName="color"></wr-color-preset-picker>
    </hau-form-field>
  </hau-form>
</wr-base-dialog>
